import { get } from 'lodash';
import moment from 'moment';
import { getFilteredRothFundsByOwner } from '../rothConversionTransaction/rothConversionTransaction.selectors';

const parseBeneficiaryData = (beneficiaries) => {
  return beneficiaries.map((b) => ({
    ...b,
    names:
      b.entity.entityType.enumerationID === 1
        ? b.entity.entityName.name
        : b.entity.names, //business
    name:
      b.entity.entityType.enumerationID === 1
        ? b.entity.entityName.name
        : b.entity.name, //business
    middleName:
      b.entity.entityType.enumerationID === 1
        ? b.entity.entityName.middleName
        : '',
    suffix:
      b.entity.entityType.enumerationID === 1 ? b.entity.entityName.suffix : '',
    type: b.type.enumerationID === 0 ? 'primary' : 'secondary',
    entityType:
      b.entity.entityType.enumerationID === 1 ? 'individual' : 'entity',
    relationship: b.relationship.displayName.toLowerCase(),
    distribution: Number((b.distribution * 100).toFixed(2)),
    dateOfBirth: b.entity.dateOfBirth
      ? moment(b.entity.dateOfBirth).format('MM-DD-YYYY')
      : '',
  }));
};

// returns beneficiary map with simplified data
export const getMappedBeneficiaries = (state) => {
  const userOwnedFunds = getFilteredRothFundsByOwner(state);
  const allBeneficiaries = get(state, 'beneficiaries.byAgreementType');
  const agreementTypes = ['Rollover IRA', 'Traditional IRA', 'Roth IRA'];
  const beneficiaryMap = allBeneficiaries.reduce((acc, group) => {
    if (agreementTypes.includes(group.agreementTypeValue.displayName)) {
      const agreementType = group.agreementTypeValue.displayName.replace(
        /\s/g,
        ''
      );

      if (!acc[agreementType]) {
        acc[agreementType] = [];
      }
      if (group.beneficiaries.length > 0) {
        if (group.agreementTypeValue.accountType === 'ROTH_IRA') {
          const temp =
            userOwnedFunds
              .map((fund) => {
                return group.agreements.some(
                  (agreement) => agreement.accountId === fund.agreementID
                );
              })
              .filter((b) => b).length > 0;
          if (temp) {
            acc[agreementType].push(parseBeneficiaryData(group.beneficiaries));
          }
        } else {
          acc[agreementType].push(parseBeneficiaryData(group.beneficiaries));
        }
      }
    }
    return acc;
  }, {});

  return beneficiaryMap;
};

export const getNumberOfRothBenes = (state) => {
  const allBeneficiaries = get(state, 'beneficiaries.byAgreementType');
  const rothBeneGroups = allBeneficiaries.filter(
    (fund) => fund.agreementTypeValue.enumerationName === 'Roth IRA'
  );
  if (rothBeneGroups && rothBeneGroups.length > 1) {
    return true;
  }
  if (rothBeneGroups && rothBeneGroups.length > 0) {
    return !rothBeneGroups[0].beneficiariesMatch;
  }
  return false;
};
